<template>
        <preview :material="material" />
</template>
<script>
import preview from '@/components/preview/Preview';
import MaterialService from '@/services/material.service';
export default {
    name:'preview-imprimir',
    data() {
        return {
            material: {},
            paramsList: {
                filtro:{}
            }
        }
    },
    components: {
        preview
    },
    created() {
        console.log('imprimir')
        /*let body = document.getElementsByTagName('body');
        body[0].classList.remove("aside-menu-show");
        body[0].classList.remove("aside-menu-lg-show");
        body[0].classList.remove("sidebar-lg-show");*/
        // Para verificar si es preview desde constructor o desde la previsualización
        if(this.$route.params.id != 'dev') {
             this.paramsList.filtro._id = this.$route.params.id;
            MaterialService.list(1, this.paramsList).then(response => {     
                let infoMaterial =  JSON.parse(JSON.stringify(response[0]));
                delete infoMaterial.content;
                this.material.info = infoMaterial;
                this.material.content = response[0].content;
            });
        }else{
            this.material =  this.$store.getters['constructor/getActivityData'];
        }
    },
}
</script>